import React from 'react';
import styled from 'styled-components';
import PText from '../components/PText';
import Button from '../components/Button';
import AboutImg from '../assets/images/about-page-img.png';
import AboutInfoItem from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;

  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
  }
`;

export default function About() {
  return (
    <>
      <AboutPageStyles>
        <div className="container">
          <div className="top-section">
            <div className="left">
              <p className="about__subheading">
                Hi, I am <span>Gaurav</span>
              </p>
              <h2 className="about__heading">Machine Learning Engineer</h2>
              <div className="about__info">
                <PText>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit
                  <br /> <br />
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit
                  <br />
                  <br />
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </PText>
              </div>
              <Button btnText="Download CV" btnLink="#" />
            </div>
            <div className="right">
              <img src={AboutImg} alt="me" />
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1 className="about__info__heading">Education</h1>

              <AboutInfoItem
                title="School"
                items={["St. Peter's College, Agra"]}
              />
              <AboutInfoItem
                title="College"
                items={['Manipal University Jaipur']}
              />
              {/* <AboutInfoItem
                title="Varsity"
                items={['University Of Chitiagong']}
              /> */}
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">My Skills</h1>

              <AboutInfoItem
                title="Programming"
                items={['Python', 'C', 'C++', 'Dart']}
              />
              <AboutInfoItem
                title="Frameworks"
                items={['Keras', 'Tensorflow', 'OpenCV', 'MediaPipe']}
              />
              <AboutInfoItem
                title="Familiar"
                items={['Flask', 'Flutter', 'Firebase']}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">Experiences</h1>

              <AboutInfoItem
                title="Jul 21 - "
                items={['App Developer at Triumb Infotech']}
              />
              <AboutInfoItem
                title="Apr - June 21"
                items={['App Developer Intern at Triumb Infotech']}
              />
              <AboutInfoItem
                title="May 21 - "
                items={['Head of IT at Randomize();']}
              />
              <AboutInfoItem
                title="Nov - Apr 21"
                items={['App Dev Mentor at Randomize();']}
              />
            </div>
          </div>
        </div>
        <ContactBanner />
      </AboutPageStyles>
    </>
  );
}
